export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => state.retrieved
export const paymentMethod = state => state.paymentMethod
export const personOrder = state => state.paymentMethod
